module.exports = __webpack_public_path__ + "img/Avatar.bfee8011.png";